import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  BackendService,
  TableSettings,
  FilterSettings,
  FieldStructure,
} from 'beyond-util';
import { IzvestajSettings } from './izvestaj-settings.service';
import { ExportService } from '../../../services/export.service';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { RtsBackendService } from 'beyond-util/src/app/shared/services/rts-backend.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-prihodi-po-emisijama',
  templateUrl: './prihodi-po-emisijama.component.html',
})
export class PrihodiPoEmisijamaComponent extends IzvestajBaseComponent
  implements OnInit, OnDestroy {
  constructor(
    public backendService: BackendService,
    private dummyService: IzvestajSettings,
    private exportService: ExportService,
    private http: HttpClient
  ) {
    super(backendService);
    this.name = 'Izveštaj prihoda po emisijama';

    console.log('Izveštaj prihoda po emisijama created');
  }

  settingsLoadSingle() {
    setTimeout(() => {
      const data = this.dummyService.prihodiPoEmisijamaTableSettings;
      this.settingsData = data;
      // this.settingsFilter = new FilterSettings(this.settingsData);
      this.settingsTable = new TableSettings(this.settingsData, 'table');
      this.settingsTableSource.next(this.settingsTable);

      // this.setAllFields(this.settingsFilter);
      this.firstTableLoad();
      this.refreshTable();
    }, 0);

    this.fieldStructure = new FieldStructure(
      this.dummyService.prihodiPoEmisijamaHeaderSettings,
      'header'
    );
    this.report = this.dummyService.headerData;
  }

  onToolbarActionExport() {
    this.exportService.exportToExcel(
      this.tables,
      this.report,
      this.settingsData.title
    );
  }

  // onToolbarActionPrint() {
  //   const pageHeader = this.exportService.createPageHeaderFromSettingsAndServiceData(
  //     this.dummyService.prihodiPoEmisijamaHeaderSettings.allFields,
  //     this.dummyService.headerData
  //   );
  //   const tableHeader = this.exportService.getLabelsArray(this.settingsLabels);
  //   const tableBody = this.exportService.getTableRowsFromServiceData(
  //     this.orderList
  //   );

  //   this.exportService.setupPage(this.name, pageHeader, tableHeader, tableBody);
  // }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/prihodi-po-emisijama/prihodi-po-emisijama.component.ts